/**
 * Persists GET /enquiry/employee-counts and GET /enquiry/filter-options per user.
 */

const EMP_KEY = 'vacspl_enquiry_employee_counts_cache';
const FIL_KEY = 'vacspl_enquiry_filter_options_cache';

function readMap(storageKey) {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
}

function writeMap(storageKey, map) {
  try {
    localStorage.setItem(storageKey, JSON.stringify(map));
  } catch (e) {
    console.warn('enquiries auxiliary cache: write failed', e);
  }
}

/** @returns {unknown | null} null = cache miss */
export function getCachedEmployeeCounts(userId) {
  const map = readMap(EMP_KEY);
  const k = userId || '';
  return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : null;
}

export function setCachedEmployeeCounts(userId, data) {
  const map = readMap(EMP_KEY);
  map[userId || ''] = data;
  writeMap(EMP_KEY, map);
}

/** @returns {{ cities: Array, states: Array } | null} */
export function getCachedFilterOptions(userId) {
  const map = readMap(FIL_KEY);
  const k = userId || '';
  if (!Object.prototype.hasOwnProperty.call(map, k)) return null;
  const v = map[k];
  if (!v || typeof v !== 'object') return null;
  return v;
}

export function setCachedFilterOptions(userId, payload) {
  const map = readMap(FIL_KEY);
  map[userId || ''] = payload;
  writeMap(FIL_KEY, map);
}

export function clearEnquiriesAuxiliaryCache() {
  try {
    localStorage.removeItem(EMP_KEY);
    localStorage.removeItem(FIL_KEY);
  } catch {
    /* ignore */
  }
}
